module.exports = __webpack_public_path__ + "img/maintenance.259428c0.jpeg";